import CustomButton from '@components/CustomButton/CustomButton'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const CreateAccountButton = () => {
  const navigate = useNavigate()
  return (
    <CustomButton
      icon={
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='17'
          height='16'
          viewBox='0 0 17 16'
          fill='none'
        >
          <path
            d='M6.5 12L10.5 8L6.5 4'
            stroke='white'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      }
      // onClick={() => {
      //   navigate('/register')
      // }}
      onClick={() => {
        const packsSection = document.getElementById('packs')
        if (packsSection) {
          packsSection.scrollIntoView({ behavior: 'smooth' })
        }
      }}
      text={'home.create_account'}
    />
  )
}

export default CreateAccountButton
